import { createSelector } from 'reselect';
import prop from 'ramda/es/prop';
import lensProp from 'ramda/es/lensProp';
import map from 'ramda/es/map';
import over from 'ramda/es/over';
import pipe from 'ramda/es/pipe';
import replace from 'ramda/es/replace';

import { toFixedValueCurrency } from 'app/common/lib/toFixedValue';


const createSelectPeriods = () => createSelector(
  [
    prop('periods'),
  ],
  map(pipe(
    over(lensProp('cost'), toFixedValueCurrency),
    over(lensProp('title'), replace(' ', '\u00A0'))
  ))
);

export default createSelectPeriods;
